import React, { useContext, useEffect, useState } from "react";
import {
  CreditDataSubtitleForm,
  CreditDataFieldTitleValorDeleteItem,
  CreditDataButtoCalculate,
  CreditDataAddButton,
} from "./styled";
import { Controller, get, useForm } from "react-hook-form";
import { dataSolicitationSteps } from "../../../helpers/enum";
import { currencyMoney } from "../../../config/currency";
import {
  DefaultLargeButton,
  SecondaryLargeButton,
} from "../../../components/Buttons/styles";
import { credits, creditLinesBack } from "../../../helpers/enum";
import FormTemplate from "../../../components/FormTemplate";
import Loader from "../../../components/Loader";
import InputIntl from "../../../components/InputIntl";
import { formatPrice } from '../../../helpers/price';
import Select from "../../../components/Select";
import ModalInfo from '../../../components/ModalInfo';
import { BsCheck, BsExclamation } from 'react-icons/bs';
import colors from '../../../assets/styles/colors';
import InputDefault from "../../../components/InputDefault";
import InputDate from "../../../components/InputDate";
import SearchField from "../../../components/SearchField";
import InputCheckbox from "../../../components/InputCheckbox";
import {
  Form,
  FormFooter,
  FormRow,
} from "../../../components/FormTemplate/styles";
import { DataSolicitationContext } from "../../../store";
import { default as DataSolicitationTypes } from "../../../store/DataSolicitation/types";
import { getCreditsByAdvisor } from "../../../services/credit";
import { getSimulacionByIdCredito } from '../../../services/simulation';
import { getCompetitors } from "../../../services/competitors";
import { useLocation } from "react-router-dom";
import {
  FinancesDataCreditCheckboxContainer,
  FinancesDataCreditCheckboxContainerLine,
  FinancesDataCreditCheckboxContainerText,
  FinancesDataCreditCheckboxContainerTitle,
  FinancesDataCreditCheckboxContainerSaldo,
  SaldoTotalRecoger,
  SaldoTotalRecogerContainer,
  FinancesDataCreditLine,
  FinancesDataCreditLineTitle,
  FinancesDataNoCredit
} from "../../Simulator/FinancesData/styles";
import { isPricing } from "../../../services/tasas";
import { getContractTypes, getExtracts } from "../../../services/extract";
import { getActivities } from "../../../services/actividades";
import { saveWorkData } from "../../../services/dataSolicitation";
import { getPaymentBill } from "../../../services/paymentbill";
import { getActivitiesPorIdPagaduria } from '../../../services/actividades';
import { getPiloto } from "../../../services/desk";
import { InfoCircleImage, Tooltip, TooltipContent, TooltipTitle } from "../../Simulator/PriceValueToSolicitate/styles";
import infoCircle from '../../../assets/images/info-circle.svg';
import { getLineasDeCredito, postIsBonoSocial } from "../../../services/lineasDeCredito";
import { getDestinosCredito, postGenerateAutorization } from "../../../services/habeasData";
import { validateClientAdvisorPaymentBill } from "../../../services/clientRegistration";
import ModalAction from "../../../components/ModalAction";

const CreditData = ({ setActiveStep, setLastStep }) => {
  const location = useLocation();
  const session = JSON.parse(localStorage.getItem("@EC-session"));
  const { dataSolicitation, setDataSolicitation } = useContext(
    DataSolicitationContext
  );
  const {
    register,
    errors,
    control,
    setValue,
    clearErrors,
    handleSubmit,
    watch,
  } = useForm({ defaultValues: dataSolicitation.creditData });
  const [showLineOfCredit, setShowLineOfCredit] = useState(false);
  const [creditsByAcesor, setCreditsByAcesor] = useState([]);
  const [isCreditsByAcesor, setIsCreditsByAcesor] = useState(false);
  const [entidad, setEntidad] = useState([]);
  const [filteredEntidad, setFilteredEntidad] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showModalInfoIngresos, setShowModalInfoIngresos] = useState(false);
  const [calculate, setCalculate] = useState(false);
  const [pricing, setPricing] = useState(false);
  const [titleErrorIngresos, setTitleErrorIngresos] = useState('');
  const fields = watch();
  const [showExtracts, setShowExtracts] = useState(false);
  const [extracts, setExtracts] = useState([]);
  const [contractTypes, setContractsType] = useState([]);
  const [showContractType, setShowContractType] = useState(false);
  const [showActivity, setShowActivity] = useState(false);
  const [activities, setActivities] = useState([]);
  const [paymentBill, setPaymentBill] = useState([]);
  const [filteredPaymentBill, setFilteredPaymentBill] = useState([]);
  const [showPaymentBill, setShowPaymentBill] = useState(false);
  const [pilotoPagaduria, setPilotoPagaduria] = useState(false);
  const [lineasDeCredito, setLineasDeCredito] = useState([]);
  const [piloto, setPiloto] = useState([]);
  const [lineasDeCreditoBD, setLineasDeCreditoBD] = useState([]);
  const [destinosCredito, setDestinosCredito] = useState([]);
  const [showDestinosCredito, setShowDestinosCredito] = useState(false);
  const [preSelectedDestinoCredito, setPreSelectedDestinoCredito] = useState(false);
  const [showModalCambioAsesor, setShowModalCambioAsesor] = useState(false);
  const [showModalCambioAsesorEnviado, setShowModalCambioAsesorEnviado] = useState(false);
  const [errores, setErrores] = useState([]);
  const [messageErrorOnCalculate, setMessageErrorOnCalculate] = useState('');
  const [titleErrorOnCalculate, setTitleErrorOnCalculate] = useState('');
  const [showModalInfoError, setShowModalInfoError] = useState(false);

  async function getCredits(lineaCredito) {
    const data = {
      tipoIdentificacion: dataSolicitation.credit.cliente.tipoIdentificacion,
      identificacion: dataSolicitation.credit.cliente.identificacion.replaceAll('.', ''),
    }
    
    setIsLoading(true);
    const creditsResponse = await getCreditsByAdvisor(data, dataSolicitation.credit.idOficina);
    setIsLoading(false);
    setCreditsByAcesor(creditsResponse.data);
    setIsCreditsByAcesor(true);
  }

  async function initializeStateComponent() {
    try {
      setIsLoading(true);
      const simulacionBD = await getSimulacionByIdCredito(location.idCredit);
      /*const response = await isPricing(simulacionBD.data.idOficina);
      setPricing(response.data)*/

      const isPilotoPagaduria = await getPiloto(simulacionBD.data.idOficina);
      setPilotoPagaduria(isPilotoPagaduria.data.isModeloPagaduria)
      setPiloto(isPilotoPagaduria.data);
      if (!isPilotoPagaduria.data.isModeloPagaduria) {
        const activities = await getActivities();
        setActivities(activities.data);
      }

      const extractResponse = await getExtracts();
      setExtracts(extractResponse.data);

      /*const activities = await getActivities();
      setActivities(activities.data);*/

      const paymentBill = await getPaymentBill();
      setPaymentBill(paymentBill.data);
      setSelectedPaymentBill(dataSolicitation.solicitation.pagaduria)

      const lineasCredito = await getLineasDeCredito();
      setLineasDeCreditoBD(lineasCredito.data)
      setLineasDeCredito(lineasCredito.data);

      const destinoCredito = await getDestinosCredito();
      const modifiedData = destinoCredito.data.map(item => ({
        ...item,
        nombre: item.destinoCredito
      }));
      setDestinosCredito(modifiedData);

      if (dataSolicitation.pricing) {
        if (dataSolicitation.basicData.estrato) {
          extractResponse.data.map((item) => {
            if (item.nombre == dataSolicitation.basicData.estrato) {
              selectExtract(item);
            }
          });
        }
      }

      if (dataSolicitation.basicData.totalActivos) {
        setValue("totalActivos", dataSolicitation.basicData.totalActivos)
      }
      setDataSolicitation({
        type: DataSolicitationTypes.SET_ID_ASESOR,
        idAsesor: simulacionBD.data.idAsesor
      })

      if (simulacionBD === null || simulacionBD === undefined) {

        dataSolicitation.creditData.ingresos = 0;
        dataSolicitation.creditData.descuentosNomina = 0;
        dataSolicitation.creditData.descuentosLey = 0;


      } else {

        dataSolicitation.creditData.ingresos = simulacionBD.data["ingresos"];
        setValue('ingresos', dataSolicitation.creditData.ingresos)

        dataSolicitation.creditData.descuentosNomina = simulacionBD.data["descuentosNomina"];
        setValue('descuentosNomina', dataSolicitation.creditData.descuentosNomina)

        dataSolicitation.creditData.descuentosLey = simulacionBD.data["descuentosLey"];
        setValue('descuentosLey', dataSolicitation.creditData.descuentosLey)

        if (simulacionBD.data["idLineaCredito"] !== null || simulacionBD.data["idLineaCredito"] !== undefined) {
          dataSolicitation.creditData.lineaCredito = lineasCredito.data.find(item => item.idBackend == simulacionBD.data["idLineaCredito"]);
          setSelectedLineOfCredit(dataSolicitation.creditData.lineaCredito);
        }
      }

      const entidadResponse = await getCompetitors();
      setEntidad(entidadResponse.data);
      await dataSolicitation.creditData.fields.forEach((item) => {
        setValue(`monto${item.id}`, item.monto);
        setValue(`valorCuota${item.id}`, item.valorCuota);
        setValue(`fechaVencimiento${item.id}`, item.fechaVencimiento);
        setValue(`noObligacdescuentosNominaion${item.id}`, item.noObligacion);
        setValue(`ingresos${item.id}`, item.ingresos);

      });
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log(error)
    }
  }

  function selectExtract(estrato) {
    setValue("estrato", estrato);

    setDataSolicitation({
      type: DataSolicitationTypes.SET_ESTRATO,
      estrato: estrato
    })
  }

  async function setLineaCreditoBonoSocial() {
    const data = {
      ingresos: parseInt(dataSolicitation.creditData.ingresos),
      numeroIdentificacion: dataSolicitation.credit.cliente.identificacion.replaceAll('.', ''),
      fechaNacimiento: dataSolicitation.basicData.fechaNacimiento,
      estrato: dataSolicitation.basicData.estrato?.idLegado
    }
    const bonoSocial = await postIsBonoSocial(data);
    if ((dataSolicitation.creditData.lineaCredito.idBackend == 6 || dataSolicitation.creditData.lineaCredito.idBackend == 7) && (!bonoSocial.data.result)) {
      setSelectedLineOfCredit({})
    }
    if (!(bonoSocial.data.result && piloto.isBonoSocial)) {
      const filteredLineasDeCredito = lineasDeCredito.filter(item => item.id !== 6 && item.id !== 7);
      setLineasDeCredito(filteredLineasDeCredito);
    } else {
      //setValue('bonoSocial',dataSolicitation.basicData?.valorDestino)
      setLineasDeCredito(lineasDeCreditoBD);
    }
  }

  function onBlurIngresos() {
    if (dataSolicitation.basicData.estrato?.idLegado && fields.ingresos) {
      dataSolicitation.creditData.ingresos = fields.ingresos;
      setValue('ingresos', dataSolicitation.creditData.ingresos)
      setLineaCreditoBonoSocial();
    }
  }


  useEffect(() => {
    if (dataSolicitation.basicData.estrato?.idLegado && fields.ingresos) {
      setLineaCreditoBonoSocial();
    }
  }, [dataSolicitation.basicData.estrato?.idLegado])

  async function setSelectedActivitie(activitie) {
    setValue("actividadCliente", activitie);
    clearErrors("actividadCliente", {});
    if (activitie.id != undefined) {
      const contractTypes = await getContractTypes(activitie.id);
      const objetoEncontrado = contractTypes.data.find((elemento) => {
        return elemento.nombre === dataSolicitation.basicData.tipoContrato?.nombre;
      });
      if (!objetoEncontrado) {
        selectContractType({});
      }
      if (dataSolicitation.basicData.tipoContrato) {
        contractTypes.data.map((item) => {
          if (item.nombre == dataSolicitation.basicData.tipoContrato) {
            selectContractType(item);
          }
        });
      }
      setContractsType(contractTypes.data);
    } else {
      selectContractType({});
    }
    setDataSolicitation({
      type: DataSolicitationTypes.SET_ACTIVITIE,
      actividadCliente: activitie
    });
    dataSolicitation.credit.actividad = activitie.nombre
  }

  function selectContractType(contracttype) {
    setValue("tipoDeContrato", contracttype);
    clearErrors("tipoDeContrato", {});

    setDataSolicitation({
      type: DataSolicitationTypes.SET_TIPO_CONTRATO,
      tipoContrato: contracttype
    })

    setShowContractType(false);
  }

  async function setSelectedPaymentBill(paymentBill) {
    setValue("pagaduria", paymentBill.nombre);
    clearErrors("pagaduria", {});
    dataSolicitation.credit.idPagaduria = paymentBill.id;
    const response = await getActivitiesPorIdPagaduria(paymentBill.id);
    const isPilotoPagaduria = await getPiloto(dataSolicitation.credit.idOficina);
    if (isPilotoPagaduria.data.isModeloPagaduria) {
      const objetoEncontrado = response.data.find((elemento) => {
        return elemento.nombre === dataSolicitation.basicData.actividadCliente?.nombre;
      })
      if (!objetoEncontrado && dataSolicitation.basicData.actividadCliente.id != undefined) {
        setSelectedActivitie({});
      }
      if (dataSolicitation.basicData.actividadCliente) {
        response.data.map((item) => {
          if (item.id == dataSolicitation.basicData.actividadCliente) {
            setSelectedActivitie(item);
          }
        });
      }
      setActivities(response.data);
    }

    setDataSolicitation({
      type: DataSolicitationTypes.SET_PAYMENT_BILL,
      pagaduria: paymentBill
    })

    setShowPaymentBill(false);
  }

  function searchInPaymentBill(e) {
    setShowPaymentBill(true);
    let filtered = paymentBill.filter(paymentBill => paymentBill.nombre.toLowerCase().indexOf(e.target.value.toLocaleLowerCase()) > -1);
    setFilteredPaymentBill(filtered);
  }

 async function setCompleteStep(dataa) {
    setIsLoading(true);
    console.log(fields.bonoSocial)
    dataSolicitation.basicData.totalActivos = dataa.totalActivos;
    if (!dataSolicitation.basicData.tipoContrato?.nombre) {
      setShowModalInfoIngresos(true)
      setTitleErrorIngresos('Seleccione tipo Contrato')
    } else {
        let dataValidation = {
          tipoIdentificacion: dataSolicitation.credit.cliente.tipoIdentificacion,
          identificacion: dataSolicitation.credit.cliente.identificacion.replaceAll('.', ''),
          idAsesor: session.idAsesor,
          idPagaduria: dataSolicitation.solicitation.pagaduria.id,
          idLineaCredito: dataSolicitation.creditData.lineaCredito.idBackend,
          simulador2: true
        };
    
        /*const response = await validateClientAdvisorPaymentBill(dataValidation);
        if(response.data.tipo == 'VALIDACIONES_FALLIDAS_POLITICA'){
          setErrores(response.data.errores[0]);
          setShowModalCambioAsesor(true);
          return;
        }else if (response.data.tipo == 'VALIDACIONES_FALLIDAS'){
          setMessageErrorOnCalculate('');
          setTitleErrorOnCalculate(response.data.errores);
          setShowModalInfoError(true)
          setIsLoading(false);
          return;
        }*/
      const data = {
        descuentosLey: (fields.descuentosNomina) ? fields.descuentosLey : 0,
        descuentosNomina: (fields.descuentosNomina) ? fields.descuentosNomina : 0,
        ingresos: fields.ingresos,
        lineaCredito: dataSolicitation.creditData.lineaCredito,
        credits: dataSolicitation.creditData.credits,
        fields: dataSolicitation.creditData.fields,
        bonoSocial: fields.bonoSocial,
        piloto: piloto
      };
      setDataSolicitation({
        type: DataSolicitationTypes.SET_CREDIT_DATA,
        creditData: data,
      });
      if (validateIngresos()) {
        setLastStep(dataSolicitationSteps.CREDIT_DATA);
        setActiveStep(dataSolicitationSteps.RESULT);
      }
    }

    setIsLoading(false);
  }

  function validateIngresos() {
    let { ingresos, descuentosNomina, descuentosLey } = fields;
    if (Number(ingresos) < Number(descuentosNomina) + Number(descuentosLey)) {
      setTitleErrorIngresos("Campos de descuentos no deben ser superiores a los ingresos.");
      setShowModalInfoIngresos(true);
      return false;
    }
    return true;
  }

  function searchInEntidad(item, id, e) {
    const filteredData = dataSolicitation.creditData.fields
      .map(function (elem) {
        elem.entidad.show = false;
        return elem;
      })
      .filter(field => field.id !== id);

    let data = item;
    data.entidad.show = true;

    setDataSolicitation({
      type: DataSolicitationTypes.SET_FIELDS,
      fields: [
        ...filteredData,
        data
      ],
    });

    let filtered = entidad.filter(paymentBill => paymentBill.nombre.toLowerCase().indexOf(e.target.value.toLocaleLowerCase()) > -1);
    setFilteredEntidad(filtered);
  }

  function setBackStep() {
    let data = {
      descuentosLey: fields.descuentosLey,
      descuentosNomina: fields.descuentosNomina,
      ingresos: fields.ingresos,
      lineaCredito: dataSolicitation.creditData.lineaCredito,
      credits: dataSolicitation.creditData.credits,
      fields: dataSolicitation.creditData.fields,
    };

    setDataSolicitation({
      type: DataSolicitationTypes.SET_CREDIT_DATA,
      creditData: data,
    });

    setActiveStep(dataSolicitationSteps.WORK_DATA);
  }

  async function setSelectedLineOfCredit(lineaCredito) {
    setCalculate(false);
    if (lineaCredito?.idBackend === creditLinesBack[2].id) {
      if (creditsByAcesor.length == 0) {
        setCalculate(true);
      }
    }
    setValue("lineaCredito", lineaCredito);
    clearErrors("lineaCredito", {});

    if ((lineaCredito?.idBackend === creditLinesBack[2].id || lineaCredito?.idBackend === creditLinesBack[3].id) && !isCreditsByAcesor) {
      getCredits();
    } else {
      setIsLoading(false);
    }

    setDataSolicitation({
      type: DataSolicitationTypes.SET_DEFAULT_CREDIT,
      credits: [],
    });

    setDataSolicitation({
      type: DataSolicitationTypes.SET_DEFAULT_INPUT,
      fields: [{
        id: 0, entidad: '', monto: '', valorCuota: '', fechaVencimiento: '', noObligacion: '',
        entidad: {
          show: false
        }
      }],
    });
    setDataSolicitation({
      type: DataSolicitationTypes.SET_CREDIT_LINE,
      lineaCredito,
    });

    if (lineaCredito.idBackend == 6) {
      setValue('bonoSocial', dataSolicitation.basicData?.valorDestino);
      setSelectedDestinoCredito({ id: 2, nombre: "Educación" });
      setPreSelectedDestinoCredito(true);
    } else if (lineaCredito.idBackend == 7) {
      setValue('bonoSocial', dataSolicitation.basicData?.valorDestino);
      setSelectedDestinoCredito({ id: 10, nombre: "Actividades Productivas" });
      setPreSelectedDestinoCredito(true);
    } else {
      const destino = {
        id: dataSolicitation.workData.data.destinoCredito?.idDestino,
        nombre: dataSolicitation.workData.data.destinoCredito?.destino
      }
      setSelectedDestinoCredito(destino)
      setPreSelectedDestinoCredito(false);
    }


  }

  function modalErrorResetDefault() {
    setShowModalInfoError(false)
    setMessageErrorOnCalculate('');
    setTitleErrorOnCalculate('Error en el servicio OnboardingServices');
  }

  function setSelectedEntidad(entidad, fieldName) {
    setValue(fieldName, entidad.nombre);
    clearErrors(fieldName, {});

    const itemKey = fieldName.replace('entidad', '');
    const filteredData = dataSolicitation.creditData.fields
      .map(function (elem) {
        elem.entidad.show = false;
        return elem;
      })
      .filter(field => field.id !== parseInt(itemKey));

    const data = dataSolicitation.creditData.fields.find(field => field.id === parseInt(itemKey));
    data.entidad.show = false;
    data.entidad = entidad;

    setDataSolicitation({
      type: DataSolicitationTypes.SET_FIELDS,
      fields: [
        ...filteredData,
        data
      ],
    });
  }

  function verifyCheckbox(checkbox) {
    let res = false;
    getListofCredits().forEach(item => {
      if (item.id === checkbox.id) {
        res = true;
        return;
      }
    });
    return res;
  }

  function setCreditToStore(credit) {
    if (credit.idPagaduria === dataSolicitation.solicitation.pagaduria?.id) {
      const newCredit = {
        id: credit.id,
        numeroRadicacion: credit.numeroRadicacion,
        saldoAlDia: credit.saldoAlDia
      };
      const filtered = getListofCredits().filter(credito => credito.id === credit.id);
      if (filtered.length > 0) {
        const newCreditList = getListofCredits().filter(credito => credito.id !== credit.id);
        setDataSolicitation({
          type: DataSolicitationTypes.SET_CREDIT_CHECKBOX,
          credits: newCreditList
        });
      } else {
        setDataSolicitation({
          type: DataSolicitationTypes.SET_CREDIT_CHECKBOX,
          credits: [...getListofCredits().filter(credito => credito.id !== undefined), newCredit]
        });
      }
    } else {
      setShowModalInfoIngresos(true);
      setTitleErrorIngresos('Crédito no pertenece a la misma pagaduría seleccionada');
    }
  }

  function getListofCredits() {
    return ((dataSolicitation.creditData.credits.length === undefined) ? [dataSolicitation.creditData.credits] : dataSolicitation.creditData.credits).filter(credito => credito.id !== undefined);
  }

  function onChangeField(name, key, value) {
    const fields = dataSolicitation.creditData.fields;
    setValue(name, value);

    const field = fields[key]

    if (name === `field${key}`) {
      field.value = value;
    }

    if (name === `monto${key}`) {
      field.monto = value;
    }

    if (name === `valorCuota${key}`) {
      field.valorCuota = value;
    }

    if (name === `fechaVencimiento${key}`) {
      field.fechaVencimiento = value;
    }

    if (name === `noObligacion${key}`) {
      field.noObligacion = value;
    }

    setDataSolicitation({
      type: DataSolicitationTypes.SET_FIELDS,
      fields,
    });
  }

  function onChangeFieldObligacion(name, key, value) {
    const MAX_LENGTH = 18;
    if (value.length > MAX_LENGTH) {
      value = value.slice(0, MAX_LENGTH);
    }

    const fields = dataSolicitation.creditData.fields;
    setValue(name, value);

    const field = fields[key]
    if (name === `noObligacion${key}`) {
      field.noObligacion = value;
    }

    setDataSolicitation({
      type: DataSolicitationTypes.SET_FIELDS,
      fields,
    });
  }

  function deleteFieldFromStore(field) {
    let fields = dataSolicitation.creditData.fields;
    fields = fields.filter((item) => item.id !== field.id);

    setDataSolicitation({
      type: DataSolicitationTypes.SET_FIELDS,
      fields,
    });
  }

  async function generateAutorization() {
    try {
      setIsLoading(true);
      setShowModalCambioAsesor(false)
      const req = new FormData();
      req.append('tipoIdentificacion', dataSolicitation.credit.cliente.tipoIdentificacion);
      req.append('identificacion', dataSolicitation.credit.cliente.identificacion.replaceAll('.', ''));
      req.append('idAsesor', session.idAsesor);
      req.append('data', errores);
      req.append('idOficina', dataSolicitation.credit.idOficina);
      const response = await postGenerateAutorization(req);
      setIsLoading(false);
      setShowModalCambioAsesorEnviado(true);
    } catch (error) {
      setIsLoading(false);
    }
  }

  /*async function setSelectedActivitie(activitie) {
    setValue("actividadCliente", activitie);
    clearErrors("actividadCliente", {});
    if(dataSolicitation.pricing){
      selectContractType({});
    }
    const contractTypes = await getContractTypes(activitie.id);
    if (dataSolicitation.basicData.tipoContrato) {
      contractTypes.data.map((item) => {
        if (item.nombre == dataSolicitation.basicData.tipoContrato) {
          selectContractType(item);
        }
      });
    }
    setContractsType(contractTypes.data);

    setDataSolicitation({
      type: DataSolicitationTypes.SET_ACTIVITIE,
      actividadCliente: activitie
    });
  }*/

  useEffect(() => {
    initializeStateComponent();
    if ((dataSolicitation.creditData.lineaCredito.idBackend === creditLinesBack[2].id || dataSolicitation.creditData.lineaCredito.idBackend === creditLinesBack[3].id) && !isCreditsByAcesor) {
      getCredits(dataSolicitation.creditData.lineaCredito);
    } else {
      setIsLoading(false);
    }

    return () => {
      setCreditsByAcesor([])
      setFilteredEntidad([])
      setEntidad([])
      setIsCreditsByAcesor(false)
    }
  }, []);

  useEffect(() => {

    if (dataSolicitation.creditData.ingresos !== '0'
      && dataSolicitation.creditData.lineaCredito) {

      if (dataSolicitation.creditData.lineaCredito.idBackend === creditLinesBack[2].id) {
        if (getListofCredits().length > 0 && creditsByAcesor.length > 0) {
          setCalculate(false)
        } else {
          setCalculate(true)
        }
      } else if (dataSolicitation.creditData.lineaCredito.idBackend === creditLinesBack[3].id) {
        if (getListofCredits().length > 0 && creditsByAcesor.length > 0) {
          setCalculate(false)
        } else {
          setCalculate(true)
        }
      } else {
        setCalculate(false)
      }
    } else {
      setCalculate(true);
    }


  }, [dataSolicitation.creditData, fields])

  function setSelectedDestinoCredito(destinoCredito) {
    setValue("destinoCredito", destinoCredito);
    clearErrors("destinoCredito", {});

    setDataSolicitation({
      type: DataSolicitationTypes.SET_DESTINO_CREDITO,
      destinoCredito: destinoCredito
    })
  }


  return (
    <FormTemplate
      idForm="credit-data-step-page"
      activeStep="3/4"
      stepLabel="Datos para el crédito"
      idCredito={location.idCredit}
    >
      <Form onSubmit={handleSubmit(setCompleteStep)}>
        <CreditDataSubtitleForm>Datos financieros</CreditDataSubtitleForm>
        {dataSolicitation.pricing &&
          <FormRow col='3'>
            <SearchField
              label="Pagaduría"
              name="pagaduria"
              id="pagaduria"
              show={showPaymentBill}
              list={filteredPaymentBill}
              defaultValue={dataSolicitation.solicitation.pagaduria?.nombre}
              selectField={setSelectedPaymentBill}
              searchInList={searchInPaymentBill}
              register={register({ required: "Este dato es obligatorio" })}
              error={errors.pagaduria}
              placeholder="Buscar..." />
            <Select
              error={errors.actividadCliente}
              setShow={setShowActivity}
              show={showActivity}
              defaultValue={dataSolicitation.basicData.actividadCliente?.nombre}
              setSelected={setSelectedActivitie}
              list={activities}
              placeholder="Seleccionar..."
              label="Actividad"
              name="actividadCliente"
              id="actividadCliente"
              register={register({ required: "Este dato es obligatorio" })} />
            <Select
              error={errors.nivelEscolaridad}
              setShow={setShowContractType}
              show={showContractType}
              defaultValue={dataSolicitation.basicData.tipoContrato?.nombre}
              setSelected={selectContractType}
              list={contractTypes}
              placeholder={dataSolicitation.basicData.actividadCliente?.nombre ? "Seleccionar..." : "Seleccione una actividad..."}
              label="Tipo de contrato / Pensión"
              name="tipoDeContrato"
              id="tipoDeContrato"
              register={register({ required: "Este dato es obligatorio" })}
              disabled={!dataSolicitation.basicData.actividadCliente?.nombre}
            />
          </FormRow>
        }
        {dataSolicitation.pricing &&
          <FormRow col="2">
            <Select
              error={errors.estrato}
              setShow={setShowExtracts}
              show={showExtracts}
              defaultValue={dataSolicitation.basicData.estrato?.nombre}
              setSelected={selectExtract}
              list={extracts}
              placeholder="Seleccionar..."
              label="Estrato"
              name="estrato"
              id="estrato"
              register={register({ required: "Este dato es obligatorio" })}
            />
            <InputIntl
              id="totalactives"
              label="Total de Activos"
              error={errors.monto}
              name="totalActivos"
              defaultValue={dataSolicitation.basicData.totalActivos}
              setValue={setValue}
              currencyConfig={currencyMoney}
              register={register({
                required: "Este dato es obligatorio",
                min: {
                  value: 1,
                  message: "Este dato es obligatorio"
                }
              })} />
          </FormRow>
        }
        <FormRow col="2">
          <InputIntl
            id="ingresos"
            label="Total ingresos mensuales"
            error={errors.ingresos}
            name="ingresos"
            defaultValue={dataSolicitation.creditData.ingresos}
            setValue={setValue}
            currencyConfig={currencyMoney}
            onBlur={() => onBlurIngresos()}
            register={register({
              required: "Este dato es obligatorio",
              min: {
                value: 1,
                message: "Este dato es obligatorio"
              }
            })}
          />
          <InputIntl
            id="descuentosNomina"
            label={<div>Total otros descuentos de nómina<InfoCircleImage src={infoCircle} alt="info" data-tip data-for='tooltip-descuentos-nomina' /></div>}
            error={errors.descuentosNomina}
            name="descuentosNomina"
            defaultValue={dataSolicitation.creditData.descuentosNomina}
            setValue={setValue}
            currencyConfig={currencyMoney}
            onBlur={() => { }}
            register={register({
              required: "Este dato es obligatorio",
              min: {
                value: 0,
                message: "Este dato es obligatorio"
              }
            })}
          />
        </FormRow>
        <Tooltip
          id='tooltip-descuentos-nomina'
          effect="solid"
          place='top'
          border
          multiline
          textColor='#05443D'
          borderColor='#25BBAB'>
          <TooltipTitle>
            Total otros descuentos de nómina
          </TooltipTitle>
          <TooltipContent>
            Deducciones que se aplican al cliente cuando se le efectúa su pago laboral.
          </TooltipContent>
        </Tooltip>
        <FormRow col="2">
          <InputIntl
            id="descuentosLey"
            label={<div>Total descuentos de ley<InfoCircleImage src={infoCircle} alt="info" data-tip data-for='tooltip-descuentos-ley' /></div>}
            error={errors.descuentosLey}
            name="descuentosLey"
            defaultValue={dataSolicitation.creditData.descuentosLey}
            setValue={setValue}
            currencyConfig={currencyMoney}
            onBlur={() => { }}
            register={register({
              required: "Este dato es obligatorio",
              min: {
                value: 0,
                message: "Este dato es obligatorio"
              }
            })}
          />
          <Select
            error={errors.lineaCredito}
            setShow={setShowLineOfCredit}
            show={showLineOfCredit}
            defaultValue={dataSolicitation.creditData.lineaCredito.nombre}
            setSelected={setSelectedLineOfCredit}
            list={lineasDeCredito}
            placeholder="Seleccionar..."
            label="Modalidad de crédito"
            name="lineaCredito"
            id="lineaCredito"
            register={register({ required: "Este dato es obligatorio" })}
          />
        </FormRow>
        <Tooltip
          id='tooltip-descuentos-ley'
          effect="solid"
          place='top'
          border
          multiline
          textColor='#05443D'
          borderColor='#25BBAB'>
          <TooltipTitle>
            Total descuentos de ley
          </TooltipTitle>
          <TooltipContent>
            Deducciones que se aplican al cliente por aportes a salud y pensión.
          </TooltipContent>
        </Tooltip>
        <FormRow>
          {(dataSolicitation.creditData.lineaCredito.idBackend == 7 || dataSolicitation.creditData.lineaCredito.idBackend == 6) &&
            <InputIntl
              id="bonoSocial"
              label={dataSolicitation.creditData.lineaCredito.idBackend == 6 ? 'Valor destinado a educación' : 'Valor destinado a actividades productivas'}
              error={errors.bonoSocial}
              name="bonoSocial"
              defaultValue={dataSolicitation.basicData?.valorDestino}
              setValue={setValue}
              currencyConfig={currencyMoney}
              register={register({
                required: "Este dato es obligatorio",
                min: {
                  value: 1,
                  message: "Este dato es obligatorio"
                }
              })} />
          }
          <Select
            error={errors.destinoCredito}
            setShow={setShowDestinosCredito}
            show={showDestinosCredito}
            defaultValue={dataSolicitation.basicData.destinoCredito?.nombre}
            setSelected={setSelectedDestinoCredito}
            list={destinosCredito}
            placeholder="Seleccionar..."
            label="Destino Credito"
            name="destinoCredito"
            id="destinoCredito"
            register={register({ required: "Este dato es obligatorio" })}
            disabled={preSelectedDestinoCredito}
          />
        </FormRow>
        <FormRow col="2">
          {dataSolicitation.creditData.lineaCredito.idBackend === creditLinesBack[2].id ||
            dataSolicitation.creditData.lineaCredito.idBackend === creditLinesBack[3].id ? (
            <FinancesDataCreditLine>
              <FinancesDataCreditLineTitle>Créditos activos</FinancesDataCreditLineTitle>
              <FinancesDataCreditCheckboxContainerLine>
                {!isLoading ? (
                  creditsByAcesor.length ? (
                    creditsByAcesor.map((item, key) => (
                      <FinancesDataCreditCheckboxContainer>
                        <InputCheckbox onClick={() => setCreditToStore(item)}
                          checked={verifyCheckbox(item)}
                          value={item.numeroRadicacion} />
                        <FinancesDataCreditCheckboxContainerText><FinancesDataCreditCheckboxContainerTitle>Pagaduría:</FinancesDataCreditCheckboxContainerTitle>{item.pagaduria.nombre}</FinancesDataCreditCheckboxContainerText>
                        <FinancesDataCreditCheckboxContainerText>Saldo al día:</FinancesDataCreditCheckboxContainerText>
                        <FinancesDataCreditCheckboxContainerSaldo>$ {formatPrice(parseInt(item.saldoAlDia))}</FinancesDataCreditCheckboxContainerSaldo>
                        <FinancesDataCreditCheckboxContainerText>
                          <FinancesDataCreditCheckboxContainerTitle>Cuota a retanquear:</FinancesDataCreditCheckboxContainerTitle>
                          <FinancesDataCreditCheckboxContainerTitle>$ {formatPrice(parseInt(item.cuota))}</FinancesDataCreditCheckboxContainerTitle>
                        </FinancesDataCreditCheckboxContainerText>
                      </FinancesDataCreditCheckboxContainer>
                    ))
                  ) : (
                    dataSolicitation.creditData.lineaCredito.idBackend === creditLinesBack[2].id ? (
                      <FinancesDataNoCredit>Cliente no tiene creditos activos, selecciona otra modalidad de crédito</FinancesDataNoCredit>
                    ) : (
                      <FinancesDataNoCredit>Cliente no tiene creditos activos</FinancesDataNoCredit>
                    )
                  )) : ''}
              </FinancesDataCreditCheckboxContainerLine>
              {!isLoading && creditsByAcesor.length ? (
                <SaldoTotalRecoger>
                  <SaldoTotalRecogerContainer>Saldo total a recoger</SaldoTotalRecogerContainer>
                  <SaldoTotalRecogerContainer>$ {formatPrice(parseInt(getListofCredits().reduce((accumulator, curr) => accumulator + curr.saldoAlDia, 0)) || 0)}</SaldoTotalRecogerContainer>
                </SaldoTotalRecoger>
              ) : ''}
            </FinancesDataCreditLine>
          ) : ''}
        </FormRow>
        {dataSolicitation.creditData.lineaCredito.idBackend === creditLinesBack[1].id ||
          dataSolicitation.creditData.lineaCredito.idBackend === creditLinesBack[3].id
          ? dataSolicitation.creditData.fields.sort(
            function (a, b) {
              if (a.id > b.id) {
                return 1;
              }
              if (a.id < b.id) {
                return -1;
              }
              // a must be equal to b
              return 0;
            }
          ).map((item, key) => (
            <>
              <CreditDataSubtitleForm>
                Valores consolidación de deudas {key + 1}
                {key > 0 && (
                  <CreditDataFieldTitleValorDeleteItem
                    onClick={() => deleteFieldFromStore(item)}
                  >
                    Eliminar Valor
                  </CreditDataFieldTitleValorDeleteItem>
                )}
              </CreditDataSubtitleForm>
              <FormRow col="2">
                <SearchField
                  label={`Entidad ${key + 1}`}
                  name={`entidad${item.id}`}
                  id={`entidad${item.id}`}
                  show={item.entidad.show}
                  list={filteredEntidad}
                  defaultValue={item.entidad.nombre}
                  selectField={setSelectedEntidad}
                  searchInList={(e) => searchInEntidad(item, item.id, e)}
                  register={register({
                    required: "Este dato es obligatorio",
                  })}
                  error={errors[`entidad${item.id}`]}
                  placeholder="Buscar..."
                />
                <InputIntl
                  id={`monto${item.id}`}
                  label={`Monto ${key + 1}`}
                  error={errors[`monto${item.id}`]}
                  name={`monto${item.id}`}
                  defaultValue={item.monto}
                  setValue={setValue}
                  currencyConfig={currencyMoney}
                  onChange={(event, value, maskedValue) =>
                    onChangeField(`monto${item.id}`, key, value)
                  }
                  onBlur={() => { }}
                  register={register({
                    required: "Este dato es obligatorio",
                    min: {
                      value: 1,
                      message: "Este dato es obligatorio",
                    },
                  })}
                />
              </FormRow>
              <FormRow col="2">
                <Controller
                  name={`valorCuota${item.id}`}
                  control={control}
                  value={item.valorCuota}
                  render={() => (
                    <InputIntl
                      id={`valorCuota${item.id}`}
                      label={`Valor de cuota ${key + 1}`}
                      error={errors[`valorCuota${item.id}`]}
                      name={`valorCuota${item.id}`}
                      defaultValue={item.valorCuota}
                      setValue={setValue}
                      currencyConfig={currencyMoney}
                      onChange={(event, value, maskedValue) =>
                        onChangeField(
                          `valorCuota${item.id}`,
                          key,
                          value
                        )
                      }
                      onBlur={() => { }}
                      register={register({
                        required: "Este dato es obligatorio",
                        min: {
                          value: 1,
                          message: "Este dato es obligatorio",
                        },
                      })}
                    />
                  )}
                />
                <InputDate
                  aria-required
                  type="date"
                  label={`FECHA DE VENCIMIENTO DEL CERTIFICADO ${key + 1}`}
                  name={`fechaVencimiento${item.id}`}
                  id={`fechaVencimiento${item.id}`}
                  error={errors[`fechaVencimiento${item.id}`]}
                  register={register}
                  onBlur={() => { }}
                  onChange={(event) =>
                    onChangeField(
                      `fechaVencimiento${item.id}`,
                      key,
                      event.target.value
                    )
                  }
                />
              </FormRow>
              <FormRow col="1">
                <Controller
                  name={`valorCuota${item.id}`}
                  control={control}
                  value={item.valorCuota}
                  render={() => (
                    <InputDefault
                      type="number"
                      name={`noObligacion${item.id}`}
                      label={`Numero de obligación ${key + 1}`}
                      register={register({
                        required: "Este dato es obligatorio",
                      })}
                      id={`noObligacion${item.id}`}
                      error={errors[`noObligacion${item.id}`]}
                      maxLength={18}
                      onChange={(event) =>
                        onChangeFieldObligacion(
                          `noObligacion${item.id}`,
                          key,
                          event.target.value
                        )
                      }
                    />
                  )}
                />
              </FormRow>
            </>
          ))
          : ""}

        {dataSolicitation.creditData.lineaCredito.idBackend === creditLinesBack[1].id ||
          dataSolicitation.creditData.lineaCredito.idBackend === creditLinesBack[3].id ? (
          <CreditDataButtoCalculate
            align={
              dataSolicitation.creditData.lineaCredito.idBackend === creditLinesBack[1].id ||
              dataSolicitation.creditData.lineaCredito.idBackend === creditLinesBack[3].id
            }
          >
            <CreditDataAddButton
              type="button"
              onClick={() =>
                setDataSolicitation({
                  type: DataSolicitationTypes.ADD_FIELD,
                  field: {
                    id: dataSolicitation.creditData.fields.length,
                    entidad: {
                      nombre: '',
                      show: false
                    },
                    monto: "",
                    valorCuota: "",
                    fechaVencimiento: "",
                    noObligacion: "",
                  },
                })
              }
              id="add-field"
            >
              + Añadir valor
            </CreditDataAddButton>
          </CreditDataButtoCalculate>
        ) : (
          ""
        )}

        <FormFooter justify="space-between">
          <DefaultLargeButton
            type="button"
            id="back-step"
            // disabled={!location.backstep}
            onClick={() => setBackStep()}
          >
            Volver
          </DefaultLargeButton>
          <SecondaryLargeButton type="submit" disabled={calculate}>Siguiente</SecondaryLargeButton>
        </FormFooter>
        {isLoading && <Loader />}
        <ModalInfo
          open={showModalInfoIngresos}
          setShowModal={setShowModalInfoIngresos}
          title={titleErrorIngresos}
          backgroundIcon={colors.bgDanger}
          bodyIcon={<BsExclamation size={32} color={colors.white} id="exclamation-icon" />} />
        <ModalAction
          open={showModalCambioAsesor}
          setShowModal={setShowModalCambioAsesor}
          actionLabelFunctionUpButton='Si, enviar solicitud'
          actionFunctionUpButton={() => generateAutorization()}
          actionLabelFunctionDownButton='Cancelar Solicitud'
          actionFunctionDownButton={() => setShowModalCambioAsesor(false)}
          title={"Estimado asesor "+session.name+","}
          description={<>En este momento no tienes autorización para iniciar la gestión con el cliente. Sin embargo, puedes solicitar un cambio de asesor.
          <br></br>¿Deseas enviar la solicitud de cambio de asesor ahora?</>}
          backgroundIcon={colors.bgDanger}
          bodyIcon={<BsExclamation size={32} color={colors.white} />} />
        <ModalAction
          open={showModalCambioAsesorEnviado}
          setShowModal={setShowModalCambioAsesorEnviado}
          title="Hemos recibido tu solicitud de cambio de asesor."
          description="En las próximas 24 horas, recibirás un correo electrónico con la respuesta a tu solicitud."
          backgroundIcon={colors.textHyperlink}
          bodyIcon={<BsCheck size={32} color={colors.white} />} />
          <ModalInfo
        open={showModalInfoError}
        setShowModal={modalErrorResetDefault}
        title={titleErrorOnCalculate}
        description={messageErrorOnCalculate}
        backgroundIcon={colors.bgDanger}
        bodyIcon={<BsExclamation size={32} color={colors.white} id="exclamation-icon" />} />
        
      </Form>
    </FormTemplate>
  );
};

export default CreditData;
